const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://easyErp-site.onrender.com/api";

const apiRequest = async (endpoint, method = 'GET', body = null) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };

    const options = {
      method,
      headers,
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, options);

    // Check if response is not ok
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Something went wrong');
    }

    return await response.json();
  } catch (error) {
    console.error(`API Error: ${error.message}`);
    throw error;
  }
};

// Feedback API functions
export const submitFeedback = async (feedbackData) => {
  return await apiRequest('/feedbacks/add', 'POST', feedbackData);
};

// Demo Request API functions
export const submitDemoRequest = async (demoData) => {
  return await apiRequest('/demo-requests/add', 'POST', demoData);
};
